import React, { Component } from 'react'
import queryString from 'query-string'
import { observer } from 'mobx-react'
import { authStore } from '../app/stores'
import Login from './Login'

class Auth extends Component {
  componentDidMount () {
    authStore.listenToAuth()
    const query = queryString.parse(this.props.location.search)
    if (query && query.token) {
      authStore.setAuthToken(query.token)
      if (this.props.replace) {
        this.props.replace(this.props.path) // clear search token
      }
    }
  }

  render () {
    return (
      <div className='Auth'>
        <Login />
      </div>
    )
  }
}

Auth.displayName = 'Auth'

export default observer(Auth)



// WEBPACK FOOTER //
// ./src/auth/Auth.js